/* RESPONSIBLE TEAM: team-automation-foundations */
export const paywallTeammateInactivity = (paywall) => ({
  component: 'workflows/editor/trigger-select-awaiting-first-reply-item-component',
  componentShouldReplaceItem: true,
  isPaywalled: true,
  paywallOpenUpgradeModal: paywall.openUpgradeModal,
  paywallAnalyticsEventData: paywall.analyticsEventData,
});
